// AUTO-GENERATED via FRA TYPEID=3008 (District Master).
// Maps dashboard's ALL-CAPS district name → FRA district code.
const FRA_DISTRICT_CODES = {
  "ARIYALUR": "610",
  "CHENGALPATTU": "730",
  "CHENNAI": "568",
  "COIMBATORE": "569",
  "CUDDALORE": "570",
  "DHARMAPURI": "571",
  "DINDIGUL": "572",
  "ERODE": "573",
  "KALLAKURICHI": "729",
  "KANCHEEPURAM": "574",
  "KANNIYAKUMARI": "575",
  "KARUR": "576",
  "KRISHNAGIRI": "577",
  "MADURAI": "578",
  "MAYILADUTHURAI": "735",
  "NAGAPATTINAM": "579",
  "NAMAKKAL": "580",
  "PERAMBALUR": "581",
  "PUDUKKOTTAI": "582",
  "RAMANATHAPURAM": "583",
  "RANIPET": "731",
  "SALEM": "584",
  "SIVAGANGAI": "585",
  "TENKASI": "733",
  "THANJAVUR": "586",
  "THE NILGIRIS": "587",
  "THENI": "588",
  "TIRUVARUR": "590",
  "THOOTHUKKUDI": "594",
  "TIRUCHIRAPPALLI": "591",
  "TIRUNELVELI": "592",
  "TIRUPATHUR": "732",
  "TIRUPPUR": "634",
  "TIRUVALLUR": "589",
  "TIRUVANNAMALAI": "593",
  "VELLORE": "595",
  "VILLUPURAM": "596",
  "VIRUDHUNAGAR": "597"
};

export const FRA_DISTRICT_MASTER = [
  {
    "code": "610",
    "name_en": "Ariyalur",
    "name_ta": "அரியலூர்"
  },
  {
    "code": "730",
    "name_en": "Chengalpattu",
    "name_ta": "செங்கல்பட்டு"
  },
  {
    "code": "568",
    "name_en": "Chennai",
    "name_ta": "சென்னை"
  },
  {
    "code": "569",
    "name_en": "Coimbatore",
    "name_ta": "கோயம்புத்தூர்"
  },
  {
    "code": "570",
    "name_en": "Cuddalore",
    "name_ta": "கடலூர்"
  },
  {
    "code": "571",
    "name_en": "Dharmapuri",
    "name_ta": "தர்மபுரி"
  },
  {
    "code": "572",
    "name_en": "Dindigul",
    "name_ta": "திண்டுக்கல்"
  },
  {
    "code": "573",
    "name_en": "Erode",
    "name_ta": "ஈரோடு"
  },
  {
    "code": "729",
    "name_en": "Kallakurichi",
    "name_ta": "கள்ளக்குறிச்சி"
  },
  {
    "code": "574",
    "name_en": "Kancheepuram",
    "name_ta": "காஞ்சிபுரம்"
  },
  {
    "code": "575",
    "name_en": "Kanniyakumari",
    "name_ta": "கன்னியாகுமரி"
  },
  {
    "code": "576",
    "name_en": "Karur",
    "name_ta": "கரூர்"
  },
  {
    "code": "577",
    "name_en": "Krishnagiri",
    "name_ta": "கிருஷ்ணகிரி"
  },
  {
    "code": "578",
    "name_en": "Madurai",
    "name_ta": "மதுரை"
  },
  {
    "code": "735",
    "name_en": "Mayiladuthurai",
    "name_ta": "மயிலாடுதுறை"
  },
  {
    "code": "579",
    "name_en": "Nagapattinam",
    "name_ta": "நாகப்பட்டினம்"
  },
  {
    "code": "580",
    "name_en": "Namakkal",
    "name_ta": "நாமக்கல்"
  },
  {
    "code": "581",
    "name_en": "Perambalur",
    "name_ta": "பெரம்பலூர்"
  },
  {
    "code": "582",
    "name_en": "Pudukkottai",
    "name_ta": "புதுக்கோட்டை"
  },
  {
    "code": "583",
    "name_en": "Ramanathapuram",
    "name_ta": "ராமநாதபுரம்"
  },
  {
    "code": "731",
    "name_en": "Ranipet",
    "name_ta": "இராணிப்பேட்டை"
  },
  {
    "code": "584",
    "name_en": "Salem",
    "name_ta": "சேலம்"
  },
  {
    "code": "585",
    "name_en": "Sivagangai",
    "name_ta": "சிவகங்கை"
  },
  {
    "code": "733",
    "name_en": "Tenkasi",
    "name_ta": "தென்காசி"
  },
  {
    "code": "586",
    "name_en": "Thanjavur",
    "name_ta": "தஞ்சாவூர்"
  },
  {
    "code": "587",
    "name_en": "The Nilgiris",
    "name_ta": "நீலகிரி"
  },
  {
    "code": "588",
    "name_en": "Theni",
    "name_ta": "தேனி"
  },
  {
    "code": "590",
    "name_en": "Thiruvarur",
    "name_ta": "தி௫வாரூர்"
  },
  {
    "code": "594",
    "name_en": "Thoothukkudi",
    "name_ta": "தூத்துக்குடி"
  },
  {
    "code": "591",
    "name_en": "Tiruchirappalli",
    "name_ta": "திருச்சிராப்பள்ளி"
  },
  {
    "code": "592",
    "name_en": "Tirunelveli",
    "name_ta": "திருநெல்வேலி"
  },
  {
    "code": "732",
    "name_en": "Tirupathur",
    "name_ta": "திருப்பத்தூர்"
  },
  {
    "code": "634",
    "name_en": "Tiruppur",
    "name_ta": "திருப்பூர்"
  },
  {
    "code": "589",
    "name_en": "Tiruvallur",
    "name_ta": "திருவள்ளூர்"
  },
  {
    "code": "593",
    "name_en": "Tiruvannamalai",
    "name_ta": "திருவண்ணாமலை"
  },
  {
    "code": "595",
    "name_en": "Vellore",
    "name_ta": "வேலூர்"
  },
  {
    "code": "596",
    "name_en": "Viluppuram",
    "name_ta": "விழுப்புரம்"
  },
  {
    "code": "597",
    "name_en": "Virudhunagar",
    "name_ta": "விருதுநகர்"
  }
];
export default FRA_DISTRICT_CODES;
